module.exports = __webpack_public_path__ + "static/img/mJsldBg@2x.de437c94.png";